<template>
  <v-container
    fluid
  >
    <v-row>
      <v-spacer></v-spacer>
      <v-col
          cols="12"
          xs="12"
          sm="12"
          md="6"
          lg="5"
          xl="4"
      >
        <v-card>
          <v-card-title>
            Sportclub BUDOKWAI Garbsen e.V.
          </v-card-title>
          <v-card-subtitle>
            L. Birkenfeld <br>
            Franziusweg 31a <br>
            30167 Hannover <br>
            Telefon: 0157-77272430
          </v-card-subtitle>
          <v-card-text>
            Vertretungsberechtigter Vorstand <br>
            Leonard Birkenfeld (1.Vorsitzender) <br>
            Falk Oberwetter (2.Vorsitzender) <br>
            Christin Hirche (Kassenwartin) <br>
            <p></p>
            Registergericht: Amtsgericht Hannover <br>
            Vereinsregisternummer: 110 177 <br>
          </v-card-text>
          <v-card-actions>
            <v-btn
                class="primary--text ml-2 mt-1"
                outlined
                rounded
                small
                @click="task('bWFpbHRvOmVyc3RlcnZvcnNpdHplbmRlckBzYy1idWRva3dhaS5kZQ==')"
            >
              <v-icon
                class="mr-1"
              >
                mdi-mail
              </v-icon>
              E-Mail
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>
            Datenschutz
          </v-card-title>
          <v-card-text>
            <h4>Grundsätzliches</h4>
            Nachfolgend möchten wir Sie über unsere Datenschutzerklärung informieren. Sie finden hier Informationen über die Erhebung und Verwendung persönlicher Daten bei der Nutzung unserer Webseite. Wir beachten dabei das für Deutschland geltende Datenschutzrecht. Sie können diese Erklärung jederzeit auf unserer Webseite abrufen. Wir weisen ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte geschützt werden kann. Die Verwendung der Kontaktdaten unseres Impressums zur gewerblichen Werbung ist ausdrücklich nicht erwünscht, es sei denn wir hatten zuvor unsere schriftliche Einwilligung erteilt oder es besteht bereits eine Geschäftsbeziehung. Der Anbieter und alle auf dieser Website genannten Personen widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.
            <p>
            <h4>Allgemeine Datenschutzerklärung</h4>
            Durch die Nutzung unserer Website erklären Sie sich mit der Erhebung, Verarbeitung und Nutzung von Daten gemäß der nachfolgenden Beschreibung einverstanden. Unsere Website kann grundsätzlich ohne Registrierung besucht werden. Dabei werden Daten wie beispielsweise aufgerufene Seiten bzw. Namen der abgerufenen Datei, Datum und Uhrzeit zu statistischen Zwecken auf dem Server gespeichert, ohne dass diese Daten unmittelbar auf Ihre Person bezogen werden. Personenbezogene Daten, insbesondere Name, Adresse oder E-Mail-Adresse werden soweit möglich auf freiwilliger Basis erhoben. Ohne Ihre Einwilligung erfolgt keine Weitergabe der Daten an Dritte.
            <p>
            <h4>Datenschutzerklärung für Cookies</h4>
            Unsere Website verwendet Cookies. Das sind kleine Textdateien, die es möglich machen, auf dem Endgerät des Nutzers spezifische, auf den Nutzer bezogene Informationen zu speichern, während er die Website nutzt. Cookies ermöglichen es, insbesondere Nutzungshäufigkeit und Nutzeranzahl der Seiten zu ermitteln, Verhaltensweisen der Seitennutzung zu analysieren, aber auch unser Angebot kundenfreundlicher zu gestalten. Cookies bleiben über das Ende einer Browser-Sitzung gespeichert und können bei einem erneuten Seitenbesuch wieder aufgerufen werden. Wenn Sie das nicht wünschen, sollten Sie Ihren Internetbrowser so einstellen, dass er die Annahme von Cookies verweigert.
            <p>
            <h4>Datenschutzerklärung für Facebook</h4>
            Unsere Website verwendet Funktionen von Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA . Bei Aufruf unserer Seiten mit Facebook-Plug-Ins wird eine Verbindung zwischen Ihrem Browser und den Servern von Facebook aufgebaut. Dabei werden bereits Daten an Facebook übertragen. Besitzen Sie einen Facebook-Account, können diese Daten damit verknüpft werden. Wenn Sie keine Zuordnung dieser Daten zu Ihrem Facebook-Account wünschen, loggen Sie sich bitte vor dem Besuch unserer Seite bei Facebook aus. Interaktionen, insbesondere das Nutzen einer Kommentarfunktion oder das Anklicken eines „Like“- oder „Teilen“-Buttons werden ebenfalls an Facebook weitergegeben. Mehr erfahren Sie unter https://de-de.facebook.com/about/privacy.
            <p>
            <h4>Auskunftsrecht</h4>
            Sie haben das jederzeitige Recht, sich unentgeltlich und unverzüglich über die zu Ihrer Person erhobenen Daten zu erkundigen. Sie haben das jederzeitige Recht, Ihre Zustimmung zur Verwendung Ihrer angegeben persönlichen Daten mit Wirkung für die Zukunft zu widerrufen. Zur Auskunftserteilung wenden Sie sich bitte an den Anbieter unter den Kontaktdaten im Impressum.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Impressum",
  methods: {
    task(b64){
      if (!b64) return;
      try {
        const decoded = atob(b64);
        window.location.href = decoded
      } catch (e) {
        console.error("Fehler beim Decodieren der Base64-Zeichenfolge:", e);
      }
    }
  }
}
</script>

<style scoped>

</style>